module.exports = __webpack_public_path__ + "static/media/menu_icon_daytraining_hover.cd99763c.png";